import React, { FC, useState, useEffect, useRef, SetStateAction, Dispatch } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

import { ReactComponent as EditIcon } from 'assets/icons/EditInfo.svg';
import IconCircle from 'components/UI/IconCircle/IconCircle';
import { ReactComponent as ImageRotateIcon } from 'assets/icons/ImageRotate.svg';

import { getImageMeta } from '../hooks';
import { StyledWrap, StyledTitleWrapper, StyledMobileRotateButton } from './styled';

const MIN_CROP = 100;
const WIDTH_CROP = 390;

interface ICropImage {
  url: string | File;
  setCropper: Dispatch<SetStateAction<Cropper | undefined>>;
}

const CropImage: FC<ICropImage> = ({ url, setCropper }) => {
  const [cropImage, setCropImage] = useState<string | undefined>(undefined);
  const [ratio, setRatio] = useState<number | null>(null);
  const cropperRef = useRef<Cropper | undefined>(undefined);

  useEffect(() => {
    if (typeof url === 'object') {
      const reader = new FileReader();
      reader.onload = () => {
        setCropImage(reader.result as string);
      };
      reader.readAsDataURL(url);
    } else {
      setCropImage(url);
    }
  }, [url]);

  useEffect(() => {
    if (cropImage) {
      getImageMeta(cropImage, (w, h) => {
        setRatio(w / h);
      });
    }
  }, [cropImage]);

  const handleRotate = () => {
    if (cropperRef.current) {
      cropperRef.current.rotate(45);
    }
  };

  return (
    <div>
      <StyledTitleWrapper>
        <IconCircle Icon={EditIcon} isDark hasBorder />
        <span>Crop</span>
      </StyledTitleWrapper>
      <StyledWrap>
        {cropImage && ratio && (
          <>
            <Cropper
              style={{ width: WIDTH_CROP, height: WIDTH_CROP / ratio, maxHeight: 'calc(70vh - 140px)' }}
              src={cropImage}
              zoomOnWheel={false}
              movable
              dragMode="move"
              viewMode={3}
              center={false}
              minCropBoxWidth={MIN_CROP}
              minCropBoxHeight={MIN_CROP}
              preview=".img-preview"
              autoCropArea={0.9}
              aspectRatio={1}
              onInitialized={(instance) => {
                cropperRef.current = instance;
                setCropper(instance);
              }}
            />
            <StyledMobileRotateButton onClick={handleRotate}>
              <ImageRotateIcon />
            </StyledMobileRotateButton>
          </>
        )}
      </StyledWrap>
    </div>
  );
};

export default CropImage;
